import React from 'react';
import { getLogoSrc } from '../utils/logoHelper';
import { formatGameDate, formatGameTime } from '../utils/dateFormatter';
import './GraphicTryoutBold.css';
import api from '../services/api';

const API_BASE_URL = api.defaults.baseURL.replace('/api', '');

function GraphicTryoutBold({
  graphicData,
  teamSport,
  teamColors,
  backgroundStyle = 'linear-gradient',
  homeTeamLogo,
  showWatermark = true,
  dateFormat = 'full',
  heroFont = 'Bebas Neue',
  heroFontSize = 160,
  accentBlockColor = null,
  detailTextColor = null,
}) {
  const {
    homeTeam,
    ageGroup,
    tryoutDate,
    tryoutTime,
    location,
    contact,
    additionalInfo,
  } = graphicData;

  const accent = accentBlockColor || teamColors.primary;
  const detailColor = detailTextColor || '#ffffff';

  const getBackgroundStyle = () => {
    switch (backgroundStyle) {
      case 'linear-gradient':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'radial-gradient':
        return `radial-gradient(circle at center, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'diagonal-gradient':
        return `linear-gradient(45deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'split-two-tone':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.primary} 50%, ${teamColors.secondary} 50%, ${teamColors.secondary} 100%)`;
      case 'solid-primary':
        return teamColors.primary;
      case 'solid-secondary':
        return teamColors.secondary;
      default:
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
    }
  };

  const isLightColor = (color) => {
    if (!color || color === 'null') return false; // Default to dark if color is null/undefined
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155;
  };

  const getBadgeColor = () => {
    const primaryLight = isLightColor(teamColors.primary);
    const secondaryLight = isLightColor(teamColors.secondary);

    if ((primaryLight && secondaryLight) || secondaryLight) {
      return '#2d3748';
    }
    return '#ffffff';
  };

  return (
    <div className="graphic-tryout-bold" id="graphic-tryout">
      {/* Header */}
      <div
        className="tryout-bold-header"
        style={{ background: getBackgroundStyle() }}
      >
        <div className="tryout-bold-logo">
          {homeTeamLogo ? (
            <div className="team-logo-circle team-logo-circle-sm">
              <img
                src={getLogoSrc(homeTeamLogo, API_BASE_URL)}
                alt={homeTeam}
                className="tryout-bold-logo-img"
              />
            </div>
          ) : (
            <div className="team-logo-circle team-logo-circle-sm">
              {teamSport === 'Softball' ? '🥎' : '⚾'}
            </div>
          )}
        </div>
        <div className="tryout-bold-badge" style={{ color: getBadgeColor(), fontFamily: heroFont, fontSize: heroFontSize * 0.15 + 'px' }}>
          TRYOUTS
        </div>
      </div>

      {/* Main content */}
      <div className="tryout-bold-content">
        <div
          className="tryout-bold-team-name"
          style={{ color: teamColors.primary }}
        >
          {homeTeam || 'TEAM NAME'}
        </div>

        {ageGroup && (
          <div
            className="tryout-bold-age-group"
            style={{
              color: isLightColor(teamColors.secondary)
                ? isLightColor(teamColors.primary)
                  ? '#2d3748'
                  : teamColors.primary
                : teamColors.secondary,
            }}
          >
            {ageGroup}
          </div>
        )}

        <div className="tryout-bold-details-grid">
          {tryoutDate && (
            <div className="tryout-bold-detail-card">
              <div className="tryout-bold-detail-header">
                <span className="tryout-bold-detail-label" style={{ color: detailColor, opacity: 0.7 }}>DATE</span>
              </div>
              <div className="tryout-bold-detail-value" style={{ color: detailColor }}>
                {formatGameDate(tryoutDate, dateFormat)}
              </div>
            </div>
          )}

          {tryoutTime && (
            <div className="tryout-bold-detail-card">
              <div className="tryout-bold-detail-header">
                <span className="tryout-bold-detail-label" style={{ color: detailColor, opacity: 0.7 }}>TIME</span>
              </div>
              <div className="tryout-bold-detail-value" style={{ color: detailColor }}>
                {formatGameTime(tryoutTime)}
              </div>
            </div>
          )}

          {location && (
            <div className="tryout-bold-detail-card">
              <div className="tryout-bold-detail-header">
                <span className="tryout-bold-detail-label" style={{ color: detailColor, opacity: 0.7 }}>LOCATION</span>
              </div>
              <div className="tryout-bold-detail-value" style={{ color: detailColor }}>{location}</div>
            </div>
          )}

          {contact && (
            <div className="tryout-bold-detail-card">
              <div className="tryout-bold-detail-header">
                <span className="tryout-bold-detail-label" style={{ color: detailColor, opacity: 0.7 }}>CONTACT</span>
              </div>
              <div className="tryout-bold-detail-value" style={{ color: detailColor }}>{contact}</div>
            </div>
          )}
        </div>

        {additionalInfo && (
          <div className="tryout-bold-additional">{additionalInfo}</div>
        )}
      </div>

      {/* Footer */}
      <div
        className="tryout-bold-footer"
        style={{ borderTop: `4px solid ${accent}` }}
      >
        {showWatermark && (
          <div className="playmaker-watermark">
            <img src="/PMlogoleft.png" alt="Playmaker Media Kit" />
          </div>
        )}
      </div>
    </div>
  );
}

export default GraphicTryoutBold;
